export enum DccProvider {
  NoDcc = 'NO_DCC',
  Fiserv = 'FISERV',
  Teya = 'TEYA',
}
